import { Button } from "@clockwise/design-system";
import React from "react";

type Props = {
  onViewEventDetails: () => void;
};

export const TimeSuggestionsFooter = ({ onViewEventDetails }: Props) => {
  return (
    <div className="cw-flex cw-p-3 cw-justify-end">
      <Button onClick={onViewEventDetails} sentiment="positive" variant="solid" size="xsmall">
        Choose my own time
      </Button>
    </div>
  );
};
